module.exports = __webpack_public_path__ + "static/media/equivalence-co2.ba7ea34f.svg";